import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export type Data = {
  id: number;
  name: string;
};

export type TestTypeData = {
  id: number;
  name: string;
  info?: string;
  is_intra_operative?: boolean;
  specimen_storage?: string;
};

type SpecialityData = {
  id: number;
  name: string;
  associate_procedures: Data[];
  associate_test_types: TestTypeData[];
};

export type SutureTypeData = {
  id: number;
  label: string;
  value: string;
};

type ReferenceData = {
  discrepancies: Data[];
  note_types: Data[];
  procedures: Data[];
  specialities: SpecialityData[];
  suture_types: SutureTypeData[];
  test_types: TestTypeData[];
};

const initialState: ReferenceData = {
  discrepancies: [],
  note_types: [],
  procedures: [],
  specialities: [],
  suture_types: [],
  test_types: [],
};

const referenceDataSlice = createSlice({
  name: 'referenceData',
  initialState,
  reducers: {
    // The API can return a partial payload (e.g. omitting `specialities`), so the
    // payload is typed Partial and merged over `initialState`. That guarantees
    // every field is a real array rather than `undefined`, protecting consumers
    // from a crash on partial runtime data — not only the `specialities` guard.
    setReferenceData: (state, action: PayloadAction<Partial<ReferenceData>>) => {
      const specialities = [...(action.payload.specialities ?? [])].sort(
        (a, b) => a.name.localeCompare(b.name),
      );
      return {...initialState, ...action.payload, specialities};
    },
    updateReferenceField: (
      state,
      action: PayloadAction<Partial<ReferenceData>>,
    ) => {
      return {...state, ...action.payload};
    },
    resetReferenceData: () => initialState,
  },
});

export const {setReferenceData, updateReferenceField, resetReferenceData} =
  referenceDataSlice.actions;

export default referenceDataSlice.reducer;
